var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-home"},[_c('Hplc'),_c('Navigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }